// import React, { useState, useEffect } from "react";
// import { Plus, Search, Trash2, Edit2 } from "lucide-react";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import axios from "axios";
// import ApiUrl from "../Environment/ApiUrl";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const CustomerTable = () => {
//   const [customerData, setCustomerData] = useState([]);
//   const [showModal, setShowModal] = useState(false);

//   // Open and close modal functions
//   const openModal = () => setShowModal(true);
//   const closeModal = () => setShowModal(false);

//   const [formData, setFormData] = useState({
//     customer_id: "",
//     name: "",
//     GSTIN: "",
//     customer_type: "",
//     mobile_number: "",
//     address: "",
//   });

//   // Validation errors state
//   const [errors, setErrors] = useState({
//     name: "",
//     customer_type: "",
//     mobile_number: "",
//     address: "",
//     GSTIN: "",
//   });

//   useEffect(() => {
//     fetchNextDealerId();
//   }, []);

//   const [generatedata, setGeneratedata] = useState("");

//   const fetchNextDealerId = async () => {
//   try {
//     const response = await axios.get(
//       `${ApiUrl}/customer_data.php/generate-customer-code`
//     );
//     console.log("fetchnextdata", response.data.customer_id);
//     setGeneratedata(response.data.customer_id);
//     setFormData((prev) => ({
//       ...prev,
//       customer_id: response.data?.customer_id,
//     }));
//   } catch (error) {
//     console.error("Error fetching Customer ID:", error);
//     if (error.response?.status === 404) {
//       toast.error("Customer code generation endpoint not found");
//     } else {
//       toast.error("Failed to fetch customer ID");
//     }
//   }
// };
//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/customer_data.php`);

//       console.log("API response.data:", response.data);

//       if (response.data && response.data.data) {
//         setCustomerData(response.data.data);
//       } else {
//         setCustomerData([]);
//       }
//     } catch (error) {
//       console.log("error is fetching", error);
//       setCustomerData([]);
//       toast.error("Failed to fetch ");
//     }
//   };

//   // GSTIN validation function
//   const validateGSTIN = (gstin) => {
//     if (!gstin) return true; // GSTIN is optional

//     const gstRegex =
//       /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
//     return gstRegex.test(gstin);
//   };

//   // Form validation function
//   const validateForm = () => {
//     let valid = true;
//     const newErrors = {
//       name: "",
//       customer_type: "",
//       mobile_number: "",
//       address: "",
//       GSTIN: "",
//     };

//     if (!formData.name.trim()) {
//       newErrors.name = "Name is required";
//       valid = false;
//     }

//     if (!formData.customer_type) {
//       newErrors.customer_type = "Customer type is required";
//       valid = false;
//     }

//     if (!formData.mobile_number.trim()) {
//       newErrors.mobile_number = "Mobile number is required";
//       valid = false;
//     } else if (!/^\d{10}$/.test(formData.mobile_number.trim())) {
//       newErrors.mobile_number = "Mobile number must be 10 digits";
//       valid = false;
//     }


//     if (formData.GSTIN && !validateGSTIN(formData.GSTIN)) {
//       newErrors.GSTIN = "Invalid GSTIN format";
//       valid = false;
//     }

//     setErrors(newErrors);
//     return valid;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     try {
//       const formDataToSend = {
//         customer_id: formData.customer_id,
//         name: formData.name,
//         GSTIN: formData.GSTIN,
//         customer_type: formData.customer_type,
//         mobile_number: formData.mobile_number,
//         address: formData.address,
//       };

//       const response = await axios.post(
//         `${ApiUrl}/customer_data.php`,
//         formDataToSend
//       );
//       console.log("submitted data", response);
//       toast.success("customer added successfully!");
//       setFormData({
//         customer_id: "",
//         name: "",
//         GSTIN: "",
//         customer_type: "",
//         mobile_number: "",
//         address: "",
//       });
//       fetchData();
//       fetchNextDealerId();
//       setShowModal(false);
//       setErrors({
//         name: "",
//         customer_type: "",
//         mobile_number: "",
//         address: "",
//         GSTIN: "",
//       });
//     } catch (error) {
//       console.log("Error Post data", error);
//     }
//   };

//   // Delete state
//   const [deleteShowModal, setDeleteShowModal] = useState(false);
//   const [deleteId, setDeleteId] = useState("");
//   const [deleteName, setDeleteName] = useState("");

//   // Delete confirmation modal
//   const handleOpenDeleteModal = (id, customer_id) => {
//     setDeleteId(id);
//     setDeleteName(customer_id);
//     setDeleteShowModal(true);
//   };

//   const handleDelete = async () => {
//     try {
//       const response = await axios.delete(
//         `${ApiUrl}/customer_data.php/${deleteId}`,
//         deleteId
//       );
//       console.log("Delete data", response);
//       toast.success(`Customer ${deleteName} deleted successfully!`);
//       setDeleteShowModal(false);
//       fetchData();
//     } catch (error) {
//       console.error("Error deleting data:", error.message);
//       toast.error("Error deleting data");
//     }
//   };

//   // Update state
//   const [updateModal, setUpdateModal] = useState(false);
//   const [updateData, setUpdateData] = useState({
//     customer_id: "",
//     name: "",
//     GSTIN: "",
//     customer_type: "",
//     mobile_number: "",
//     address: "",
//   });
//   const [updateId, setUpdateId] = useState();
//   const [updateErrors, setUpdateErrors] = useState({
//     name: "",
//     customer_type: "",
//     mobile_number: "",
//     address: "",
//     GSTIN: "",
//   });

//   const handleUpdate = (id, data) => {
//     setUpdateModal(true);
//     setUpdateId(id);
//     setUpdateData({
//       customer_id: data.customer_id,
//       name: data.name,
//       GSTIN: data.GSTIN,
//       customer_type: data.customer_type,
//       mobile_number: data.mobile_number,
//       address: data.address,
//     });
//   };

//   // Update form validation
//   const validateUpdateForm = () => {
//     let valid = true;
//     const newErrors = {
//       name: "",
//       customer_type: "",
//       mobile_number: "",
//       address: "",
//       GSTIN: "",
//     };

//     if (!updateData.name.trim()) {
//       newErrors.name = "Name is required";
//       valid = false;
//     }

//     if (!updateData.customer_type) {
//       newErrors.customer_type = "Customer type is required";
//       valid = false;
//     }

//     if (!updateData.mobile_number.trim()) {
//       newErrors.mobile_number = "Mobile number is required";
//       valid = false;
//     } else if (!/^\d{10}$/.test(updateData.mobile_number.trim())) {
//       newErrors.mobile_number = "Mobile number must be 10 digits";
//       valid = false;
//     }

   
//     if (updateData.GSTIN && !validateGSTIN(updateData.GSTIN)) {
//       newErrors.GSTIN = "Invalid GSTIN format";
//       valid = false;
//     }

//     setUpdateErrors(newErrors);
//     return valid;
//   };

//   const handleUpdateSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateUpdateForm()) {
//       return;
//     }

//     try {
//       const formDataToSend = {
//         customer_id: updateData.customer_id,
//         name: updateData.name,
//         GSTIN: updateData.GSTIN,
//         customer_type: updateData.customer_type,
//         mobile_number: updateData.mobile_number,
//         address: updateData.address,
//       };

//       const response = await axios.put(
//         `${ApiUrl}/customer_data.php/${updateId}`,
//         formDataToSend
//       );
//       toast.success("Customer updated successfully!");
//       console.log("update Api", response);
//       setUpdateModal(false);
//       fetchData();
//     } catch (error) {
//       console.log("update data error", error.message);
//     }
//   };

//   // Search and pagination
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(5);

//   const filteredCustomers = customerData.filter((customer) =>
//     Object.values(customer)
//       .join(" ")
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentCustomers = filteredCustomers.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   return (
//     <div className="bg-white font-sans">
//       <ToastContainer
//         position="top-right"
//         autoClose={3000}
//         hideProgressBar={false}
//         closeOnClick
//         pauseOnHover
//       />
//       {/* Header */}
//       <div className="p-3 p-md-4 bg-white">
//         <div className="d-flex justify-content-between align-items-center">
//           <h2 className="m-0 fs-5 fw-semibold text-dark">Customers</h2>
//           <button
//             className="btn btn-danger d-flex align-items-center gap-2"
//             onClick={openModal}
//           >
//             <Plus size={18} />
//             Add Customer
//           </button>
//         </div>
//       </div>

//       {/* Main Card Container */}
//       <div className="card mx-3 mx-md-4 border">
//         {/* Controls Row */}
//         <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
//           {/* Show All Dropdown */}
//           <div
//             className="d-flex align-items-center gap-2"
//             style={{ height: "36px", width: "120px" }}
//           >
//             <div
//               className="d-flex align-items-center justify-content-center"
//               style={{ height: "28px", width: "14px" }}
//             >
//               <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
//                 <rect x="1" y="1" width="3" height="3" fill="#666" />
//                 <rect x="1" y="5" width="3" height="3" fill="#666" />
//                 <rect x="1" y="9" width="3" height="2" fill="#666" />
//                 <rect x="5" y="1" width="6" height="1" fill="#666" />
//                 <rect x="5" y="3" width="6" height="1" fill="#666" />
//                 <rect x="5" y="5" width="6" height="1" fill="#666" />
//                 <rect x="5" y="7" width="6" height="1" fill="#666" />
//                 <rect x="5" y="9" width="6" height="1" fill="#666" />
//               </svg>
//             </div>
//             <select
//               className="border-0 bg-transparent text-dark form-select form-select-sm"
//               style={{
//                 boxShadow: "none",
//                 outline: "none",
//                 lineHeight: "1.1",
//                 height: "28px",
//                 cursor: "pointer",
//                 width: "80px",
//                 paddingTop: "0",
//                 paddingBottom: "0",
//               }}
//               value={itemsPerPage}
//               onChange={(e) => {
//                 setItemsPerPage(Number(e.target.value));
//                 setCurrentPage(1);
//               }}
//             >
//               <option value="5">Show 5</option>
//               <option value="10">Show 10</option>
//               <option value="25">Show 25</option>
//               <option value={filteredCustomers.length}>Show All</option>
//             </select>
//           </div>

//           {/* Search */}
//           <div className="position-relative" style={{ width: "280px" }}>
//             <input
//               type="text"
//               placeholder="Search"
//               className="w-100 ps-3 pe-5 py-2 border rounded form-control"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <Search
//               size={18}
//               className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
//               style={{ pointerEvents: "none" }}
//             />
//           </div>
//         </div>

//         {/* Table Container */}
//         <div className="card-body p-0">
//           {/* Table */}
//           <div className="table-responsive">
//             <table className="table table-hover mb-0 text-center">
//               <thead>
//                 <tr>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className=" p-3  fw-semibold small "
//                   >
//                     S.No
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className=" p-3  fw-semibold small "
//                   >
//                     Customer ID
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className=" p-3  fw-semibold small "
//                   >
//                     Name
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className=" p-3  fw-semibold small "
//                   >
//                     Customer Type
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className=" p-3  fw-semibold small "
//                   >
//                     Mobile Number
//                   </th>
//                   <th
//                     style={{ backgroundColor: "#d3d3d3" }}
//                     className=" p-3  fw-semibold small "
//                   >
//                     Action
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentCustomers.length > 0 ? (
//                   currentCustomers.map((items, index) => (
//                     <tr key={index} style={{ fontSize: "14px" }}>
//                       <td>{startIndex + index + 1}</td>
//                       <td>{items.customer_id}</td>
//                       <td>{items.name}</td>
//                       <td>{items.customer_type}</td>
//                       <td>{items.mobile_number}</td>
//                       <td className=" small">
//                         <div className="d-flex">
//                           <button
//                             className="p-1 border-0 bg-transparent cursor-pointer text-muted"
//                             onClick={() =>
//                               handleOpenDeleteModal(items.id, items.customer_id)
//                             }
//                           >
//                             <Trash2 size={16} />
//                           </button>
//                           <button
//                             className="p-1 border-0 bg-transparent cursor-pointer text-muted"
//                             onClick={() => handleUpdate(items.id, items)}
//                           >
//                             <Edit2 size={16} />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={8} className="text-center p-5">
//                       No data available.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {itemsPerPage < filteredCustomers.length && (
//             <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//                 className={`btn btn-sm d-flex align-items-center gap-2 ${
//                   currentPage === 1
//                     ? "bg-light text-muted"
//                     : "bg-white text-dark"
//                 }`}
//               >
//                 <FaChevronLeft size={14} />
//                 <span className="ms-1 d-none d-md-inline">Previous</span>
//               </button>

//               <div className="d-flex gap-1">
//                 {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                   let pageNum;
//                   if (totalPages <= 5) {
//                     pageNum = i + 1;
//                   } else if (currentPage <= 3) {
//                     pageNum = i + 1;
//                   } else if (currentPage >= totalPages - 2) {
//                     pageNum = totalPages - 4 + i;
//                   } else {
//                     pageNum = currentPage - 2 + i;
//                   }

//                   return (
//                     <button
//                       key={pageNum}
//                       onClick={() => setCurrentPage(pageNum)}
//                       className={`btn btn-sm ${
//                         pageNum === currentPage
//                           ? "bg-danger bg-opacity-10 text-danger"
//                           : "bg-white text-dark"
//                       }`}
//                       style={{ width: "32px", height: "32px" }}
//                     >
//                       {pageNum}
//                     </button>
//                   );
//                 })}
//                 {totalPages > 5 && currentPage < totalPages - 2 && (
//                   <span className="px-2 py-1">...</span>
//                 )}
//                 {totalPages > 5 && currentPage < totalPages - 2 && (
//                   <button
//                     onClick={() => setCurrentPage(totalPages)}
//                     className={`btn btn-sm ${
//                       totalPages === currentPage
//                         ? "bg-danger bg-opacity-10 text-danger"
//                         : "bg-white text-dark"
//                     }`}
//                     style={{ width: "32px", height: "32px" }}
//                     >
//                     {totalPages}
//                   </button>
//                 )}
//               </div>

//               <button
//                 onClick={() =>
//                   setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                 }
//                 disabled={currentPage === totalPages}
//                 className={`btn btn-sm d-flex align-items-center gap-2 ${
//                   currentPage === totalPages
//                     ? "bg-light text-muted"
//                     : "bg-white text-dark"
//                 }`}
//               >
//                 <span className="ms-1 d-none d-md-inline">Next</span>
//                 <FaChevronRight size={14} />
//               </button>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Customer data add popup */}
//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{
//           display: showModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="addCustomerModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div
//             className="modal-content"
//             style={{ backgroundColor: " rgb(255, 240, 245)" }}
//           >
//             <div className="modal-header bg-pink-light border-bottom-0">
//               <h5 className="modal-title m-0  fw-semibold">Add Customer</h5>
//               <button
//                 type="button"
//                 className="btn btn-close"
//                 onClick={closeModal}
//               ></button>
//             </div>

//             <div className="modal-body bg-pink-light">
//               <div className="row ">
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Customer ID <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     name="customer_id"
//                     value={generatedata}
//                     readOnly
//                     placeholder="Enter Customer ID"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Name <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className={`form-control form-control-sm ${
//                       errors.name ? "is-invalid" : ""
//                     }`}
//                     name="name"
//                     value={formData.name}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         name: e.target.value,
//                       })
//                     }
//                     placeholder="Enter Name"
//                   />
//                   {errors.name && (
//                     <div className="invalid-feedback small">{errors.name}</div>
//                   )}
//                 </div>

//                 <div className="col-md-6 mt-1">
//                   <label className="form-label small fw-medium">GSTIN</label>
//                   <input
//                     type="text"
//                     className={`form-control form-control-sm ${
//                       errors.GSTIN ? "is-invalid" : ""
//                     }`}
//                     name="GSTIN"
//                     value={formData.GSTIN}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         GSTIN: e.target.value,
//                       })
//                     }
//                     placeholder="Enter GSTIN (e.g., 22AAAAA0000A1Z5)"
//                   />
//                   {errors.GSTIN && (
//                     <div className="invalid-feedback small">{errors.GSTIN}</div>
//                   )}
                  
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium mt-3">
//                     Customer Type <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className={`form-select form-select-sm ${
//                       errors.customer_type ? "is-invalid" : ""
//                     }`}
//                     name="customer_type"
//                     value={formData.customer_type}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         customer_type: e.target.value,
//                       })
//                     }
//                   >
//                     <option value="">Select Customer Type</option>
//                     <option value="Regular">Regular</option>
//                     <option value="Dealer">Dealer</option>
//                   </select>
//                   {errors.customer_type && (
//                     <div className="invalid-feedback small">
//                       {errors.customer_type}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-6">
//                     <label className="form-label small fw-medium mt-3">
//                     Mobile Number <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className={`form-control form-control-sm ${
//                       errors.mobile_number ? "is-invalid" : ""
//                     }`}
//                     name="mobile_number"
//                     value={formData.mobile_number}
//                     onChange={(e) => {
//                       // Allow only digits and limit to 10 characters
//                       const onlyDigits = e.target.value
//                         .replace(/\D/g, "")
//                         .slice(0, 10);
//                       setFormData({
//                         ...formData,
//                         mobile_number: onlyDigits,
//                       });
//                     }}
//                     placeholder="Enter Mobile Number"
//                     maxLength={10}
//                   />
//                   {errors.mobile_number && (
//                     <div className="invalid-feedback small">
//                       {errors.mobile_number}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-6">
//                    <label className="form-label small fw-medium mt-3">
//                     Address <span className="text-danger">*</span>
//                   </label>
//                   <textarea
//                     className={`form-control form-control-sm ${
//                       errors.address ? "is-invalid" : ""
//                     }`}
//                     name="address"
//                     value={formData.address}
//                     onChange={(e) =>
//                       setFormData({ ...formData, address: e.target.value })
//                     }
//                     placeholder="Enter Address"
//                     rows="2"
//                   />
              
//                 </div>
//                 <div className="col-12">
               
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer border-top-0">
//               <button
//                 type="button"
//                 className="btn btn-sm btn-danger"
//                 data-bs-dismiss="modal"
//                 onClick={closeModal}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-sm btn-success"
//                 onClick={handleSubmit}
//               >
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Customer data delete popup */}
//       <div
//         className={`modal fade ${deleteShowModal ? "show" : ""}`}
//         style={{
//           display: deleteShowModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="deleteConfirmModalLabel"
//         aria-modal="true"
//       >
//         <div className="modal-dialog modal-dialog-centered modal-confirm">
//           <div className="modal-content">
//             <div className="modal-body text-center">
//               <div className="d-flex justify-content-center mb-3">
//                 <div
//                   className="icon-box bg-light rounded-circle d-flex align-items-center justify-content-center"
//                   style={{ width: "80px", height: "80px" }}
//                 >
//                   <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
//                 </div>
//               </div>
//               <h4 className="modal-title mb-3">Are you sure?</h4>
//               <h6 className="mb-4">
//                 Do you really want to delete this{" "}
//                 <span className="text-primary">({deleteName}</span>
//                 )?
//               </h6>
//               <div className="d-flex btn-group">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm flex-grow-1"
//                   onClick={() => setDeleteShowModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-danger btn-sm flex-grow-1 mx-2"
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Update Customer popup */}
//       <div
//         className={`modal fade ${updateModal ? "show" : ""}`}
//         style={{
//           display: updateModal ? "block" : "none",
//           backgroundColor: "rgba(0,0,0,0.5)",
//         }}
//         tabIndex="-1"
//         aria-labelledby="updateCustomerModalLabel"
//         aria-hidden={!updateModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div
//             className="modal-content rounded"
//             style={{ backgroundColor: " rgb(255, 240, 245)" }}
//           >
//             <div className="modal-header bg-pink-light border-bottom-0">
//               <h5 className="modal-title m-0  fw-semibold">Update Customer</h5>
//               <button
//                 type="button"
//                 className="btn btn-close"
//                 onClick={() => setUpdateModal(false)}
//               ></button>
//             </div>

//             <div className="modal-body bg-pink-light">
//               <div className="row ">
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Customer ID <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     name="customer_id"
//                     value={updateData.customer_id}
//                     readOnly
//                     placeholder="Enter Customer ID"
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium">
//                     Name <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className={`form-control form-control-sm ${
//                       updateErrors.name ? "is-invalid" : ""
//                     }`}
//                     name="name"
//                     value={updateData.name}
//                     onChange={(e) =>
//                       setUpdateData({
//                         ...updateData,
//                         name: e.target.value,
//                       })
//                     }
//                     placeholder="Enter Name"
//                   />
//                   {updateErrors.name && (
//                     <div className="invalid-feedback small">
//                       {updateErrors.name}
//                     </div>
//                   )}
//                 </div>

//                 <div className="col-md-6 mt-1">
//                   <label className="form-label small fw-medium">GSTIN</label>
//                   <input
//                     type="text"
//                     className={`form-control form-control-sm ${
//                       updateErrors.GSTIN ? "is-invalid" : ""
//                     }`}
//                     name="GSTIN"
//                     value={updateData.GSTIN}
//                     onChange={(e) =>
//                       setUpdateData({
//                         ...updateData,
//                         GSTIN: e.target.value,
//                       })
//                     }
//                     placeholder="Enter GSTIN (e.g., 22AAAAA0000A1Z5)"
//                   />
//                   {updateErrors.GSTIN && (
//                     <div className="invalid-feedback small">
//                       {updateErrors.GSTIN}
//                     </div>
//                   )}
//                 </div>

//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium mt-2">
//                     Customer Type <span className="text-danger">*</span>
//                   </label>
//                   <select
//                     className={`form-select form-select-sm ${
//                       updateErrors.customer_type ? "is-invalid" : ""
//                     }`}
//                     name="customer_type"
//                     value={updateData.customer_type}
//                     onChange={(e) =>
//                       setUpdateData({
//                         ...updateData,
//                         customer_type: e.target.value,
//                       })
//                     }
//                   >
//                     <option value="">Select Customer Type</option>
//                     <option value="Regular">Regular</option>
//                     <option value="Dealer">Dealer</option>
//                     <option value="Walk-in">Walk-in</option>
//                   </select>
//                   {updateErrors.customer_type && (
//                     <div className="invalid-feedback small">
//                       {updateErrors.customer_type}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label small fw-medium mt-2">
//                     Mobile Number <span className="text-danger">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     className={`form-control form-control-sm ${
//                       updateErrors.mobile_number ? "is-invalid" : ""
//                     }`}
//                     name="mobile_number"
//                     value={updateData.mobile_number}
//                     onChange={(e) => {
//                       // Allow only digits and limit to 10
//                       const digitsOnly = e.target.value
//                         .replace(/\D/g, "")
//                         .slice(0, 10);
//                       setUpdateData({
//                         ...updateData,
//                         mobile_number: digitsOnly,
//                       });
//                     }}
//                     placeholder="Enter Mobile Number"
//                     maxLength={10}
//                   />
//                   {updateErrors.mobile_number && (
//                     <div className="invalid-feedback small">
//                       {updateErrors.mobile_number}
//                     </div>
//                   )}
//                 </div>
//                 <div className="col-md-6">
//                       <label className="form-label small fw-medium mt-2">
//                     Address <span className="text-danger">*</span>
//                   </label>
//                   <textarea
//                     className={`form-control form-control-sm ${
//                       updateErrors.address ? "is-invalid" : ""
//                     }`}
//                     name="address"
//                     value={updateData.address}
//                     onChange={(e) =>
//                       setUpdateData({ ...updateData, address: e.target.value })
//                     }
//                     placeholder="Enter Address"
//                     rows="2"
//                   />
                
//                 </div>
//                 <div className="col-12">
              
//                 </div>
//               </div>
//             </div>

//             <div className="modal-footer border-top-0">
//               <button
//                 type="button"
//                 className="btn btn-sm btn-danger"
//                 onClick={() => setUpdateModal(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-sm btn-success"
//                 onClick={handleUpdateSubmit}
//               >
//                 Update
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CustomerTable;


import React, { useState, useEffect } from "react";
import { Plus, Search, Trash2, Edit2 } from "lucide-react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import ApiUrl from "../Environment/ApiUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CustomerTable = () => {
  const [customerData, setCustomerData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [privileges, setPrivileges] = useState(null);

  // Open and close modal functions
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const [formData, setFormData] = useState({
    customer_id: "",
    name: "",
    GSTIN: "",
    customer_type: "",
    mobile_number: "",
    address: "",
  });

  // Validation errors state
  const [errors, setErrors] = useState({
    name: "",
    customer_type: "",
    mobile_number: "",
    address: "",
    GSTIN: "",
  });

  // Get user role from localStorage
  useEffect(() => {
    const getaccess = localStorage.getItem("role");
    setPrivileges(getaccess);
  }, []);

  useEffect(() => {
    fetchNextDealerId();
  }, []);

  const [generatedata, setGeneratedata] = useState("");

  const fetchNextDealerId = async () => {
    try {
      const response = await axios.get(
        `${ApiUrl}/customer_data.php/generate-customer-code`
      );
      setGeneratedata(response.data.customer_id);
      setFormData((prev) => ({
        ...prev,
        customer_id: response.data?.customer_id,
      }));
    } catch (error) {
      console.error("Error fetching Customer ID:", error);
      if (error.response?.status === 404) {
        toast.error("Customer code generation endpoint not found");
      } else {
        toast.error("Failed to fetch customer ID");
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/customer_data.php`);
      if (response.data && response.data.data) {
        setCustomerData(response.data.data);
      } else {
        setCustomerData([]);
      }
    } catch (error) {
      console.log("error is fetching", error);
      setCustomerData([]);
      toast.error("Failed to fetch data");
    }
  };

  // GSTIN validation function
  const validateGSTIN = (gstin) => {
    if (!gstin) return true; // GSTIN is optional
    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return gstRegex.test(gstin);
  };

  // Form validation function
  const validateForm = () => {
    let valid = true;
    const newErrors = {
      name: "",
      customer_type: "",
      mobile_number: "",
      address: "",
      GSTIN: "",
    };

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
      valid = false;
    }

    if (!formData.customer_type) {
      newErrors.customer_type = "Customer type is required";
      valid = false;
    }

    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = "Mobile number is required";
      valid = false;
    } else if (!/^\d{10}$/.test(formData.mobile_number.trim())) {
      newErrors.mobile_number = "Mobile number must be 10 digits";
      valid = false;
    }

    if (formData.GSTIN && !validateGSTIN(formData.GSTIN)) {
      newErrors.GSTIN = "Invalid GSTIN format";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      const formDataToSend = {
        customer_id: formData.customer_id,
        name: formData.name,
        GSTIN: formData.GSTIN,
        customer_type: formData.customer_type,
        mobile_number: formData.mobile_number,
        address: formData.address,
      };

      const response = await axios.post(
        `${ApiUrl}/customer_data.php`,
        formDataToSend
      );
      toast.success("Customer added successfully!");
      setFormData({
        customer_id: "",
        name: "",
        GSTIN: "",
        customer_type: "",
        mobile_number: "",
        address: "",
      });
      fetchData();
      fetchNextDealerId();
      setShowModal(false);
      setErrors({
        name: "",
        customer_type: "",
        mobile_number: "",
        address: "",
        GSTIN: "",
      });
    } catch (error) {
      console.log("Error Post data", error);
      toast.error("Failed to add customer");
    }
  };

  // Delete state
  const [deleteShowModal, setDeleteShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteName, setDeleteName] = useState("");

  // Delete confirmation modal
  const handleOpenDeleteModal = (id, customer_id) => {
    setDeleteId(id);
    setDeleteName(customer_id);
    setDeleteShowModal(true);
  };

  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `${ApiUrl}/customer_data.php/${deleteId}`
      );
      toast.success(`Customer ${deleteName} deleted successfully!`);
      setDeleteShowModal(false);
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Error deleting data");
    }
  };

  // Update state
  const [updateModal, setUpdateModal] = useState(false);
  const [updateData, setUpdateData] = useState({
    customer_id: "",
    name: "",
    GSTIN: "",
    customer_type: "",
    mobile_number: "",
    address: "",
  });
  const [updateId, setUpdateId] = useState();
  const [updateErrors, setUpdateErrors] = useState({
    name: "",
    customer_type: "",
    mobile_number: "",
    address: "",
    GSTIN: "",
  });

  const handleUpdate = (id, data) => {
    setUpdateModal(true);
    setUpdateId(id);
    setUpdateData({
      customer_id: data.customer_id,
      name: data.name,
      GSTIN: data.GSTIN,
      customer_type: data.customer_type,
      mobile_number: data.mobile_number,
      address: data.address,
    });
  };

  // Update form validation
  const validateUpdateForm = () => {
    let valid = true;
    const newErrors = {
      name: "",
      customer_type: "",
      mobile_number: "",
      address: "",
      GSTIN: "",
    };

    if (!updateData.name.trim()) {
      newErrors.name = "Name is required";
      valid = false;
    }

    if (!updateData.customer_type) {
      newErrors.customer_type = "Customer type is required";
      valid = false;
    }

    if (!updateData.mobile_number.trim()) {
      newErrors.mobile_number = "Mobile number is required";
      valid = false;
    } else if (!/^\d{10}$/.test(updateData.mobile_number.trim())) {
      newErrors.mobile_number = "Mobile number must be 10 digits";
      valid = false;
    }

    if (updateData.GSTIN && !validateGSTIN(updateData.GSTIN)) {
      newErrors.GSTIN = "Invalid GSTIN format";
      valid = false;
    }

    setUpdateErrors(newErrors);
    return valid;
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    if (!validateUpdateForm()) {
      return;
    }

    try {
      const formDataToSend = {
        customer_id: updateData.customer_id,
        name: updateData.name,
        GSTIN: updateData.GSTIN,
        customer_type: updateData.customer_type,
        mobile_number: updateData.mobile_number,
        address: updateData.address,
      };

      const response = await axios.put(
        `${ApiUrl}/customer_data.php/${updateId}`,
        formDataToSend
      );
      toast.success("Customer updated successfully!");
      setUpdateModal(false);
      fetchData();
    } catch (error) {
      console.log("update data error", error.message);
      toast.error("Failed to update customer");
    }
  };

  // Print function (example implementation)
  const handlePrint = () => {
    window.print();
  };

  // Search and pagination
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const filteredCustomers = customerData.filter((customer) =>
    Object.values(customer)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentCustomers = filteredCustomers.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <div className="bg-white font-sans">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
      {/* Header */}
      <div className="p-3 p-md-4 bg-white">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="m-0 fs-5 fw-semibold text-dark">Customers</h2>
          <div className="d-flex gap-2">
            {(privileges === "Admin" || privileges === "Manager" || privileges === "Staff") && (
              <button
                className="btn btn-danger d-flex align-items-center gap-2"
                onClick={openModal}
              >
                <Plus size={18} />
                Add Customer
              </button>
            )}
         
          </div>
        </div>
      </div>

      {/* Main Card Container */}
      <div className="card mx-3 mx-md-4 border">
        {/* Controls Row */}
        <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
          <div
            className="d-flex align-items-center gap-2"
            style={{ height: "36px", width: "120px" }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ height: "28px", width: "14px" }}
            >
              <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                <rect x="1" y="1" width="3" height="3" fill="#666" />
                <rect x="1" y="5" width="3" height="3" fill="#666" />
                <rect x="1" y="9" width="3" height="2" fill="#666" />
                <rect x="5" y="1" width="6" height="1" fill="#666" />
                <rect x="5" y="3" width="6" height="1" fill="#666" />
                <rect x="5" y="5" width="6" height="1" fill="#666" />
                <rect x="5" y="7" width="6" height="1" fill="#666" />
                <rect x="5" y="9" width="6" height="1" fill="#666" />
              </svg>
            </div>
            <select
              className="border-0 bg-transparent text-dark form-select form-select-sm"
              style={{
                boxShadow: "none",
                outline: "none",
                lineHeight: "1.1",
                height: "28px",
                cursor: "pointer",
                width: "80px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="5">Show 5</option>
              <option value="10">Show 10</option>
              <option value="25">Show 25</option>
              <option value={filteredCustomers.length}>Show All</option>
            </select>
          </div>

          <div className="position-relative" style={{ width: "280px" }}>
            <input
              type="text"
              placeholder="Search"
              className="w-100 ps-3 pe-5 py-2 border rounded form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Search
              size={18}
              className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
              style={{ pointerEvents: "none" }}
            />
          </div>
        </div>

        {/* Table Container */}
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0 text-center">
              <thead>
                <tr>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    S.No
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Customer ID
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Name
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Customer Type
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Mobile Number
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className="p-3 fw-semibold small"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentCustomers.length > 0 ? (
                  currentCustomers.map((items, index) => (
                    <tr key={index} style={{ fontSize: "14px" }}>
                      <td>{startIndex + index + 1}</td>
                      <td>{items.customer_id}</td>
                      <td>{items.name}</td>
                      <td>{items.customer_type}</td>
                      <td>{items.mobile_number}</td>
                      <td className="small">
                        <div className="d-flex justify-content-center gap-2">
                          {privileges === "Admin" && (
                            <button
                              className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                              onClick={() =>
                                handleOpenDeleteModal(items.id, items.customer_id)
                              }
                            >
                              <Trash2 size={16} />
                            </button>
                          )}
                          {(privileges === "Admin" || privileges === "Manager") && (
                            <button
                              className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                              onClick={() => handleUpdate(items.id, items)}
                            >
                              <Edit2 size={16} />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center p-5">
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {itemsPerPage < filteredCustomers.length && (
            <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className={`btn btn-sm d-flex align-items-center gap-2 ${
                  currentPage === 1
                    ? "bg-light text-muted"
                    : "bg-white text-dark"
                }`}
              >
                <FaChevronLeft size={14} />
                <span className="ms-1 d-none d-md-inline">Previous</span>
              </button>

              <div className="d-flex gap-1">
                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                  let pageNum;
                  if (totalPages <= 5) {
                    pageNum = i + 1;
                  } else if (currentPage <= 3) {
                    pageNum = i + 1;
                  } else if (currentPage >= totalPages - 2) {
                    pageNum = totalPages - 4 + i;
                  } else {
                    pageNum = currentPage - 2 + i;
                  }

                  return (
                    <button
                      key={pageNum}
                      onClick={() => setCurrentPage(pageNum)}
                      className={`btn btn-sm ${
                        pageNum === currentPage
                          ? "bg-danger bg-opacity-10 text-danger"
                          : "bg-white text-dark"
                      }`}
                      style={{ width: "32px", height: "32px" }}
                    >
                      {pageNum}
                    </button>
                  );
                })}
                {totalPages > 5 && currentPage < totalPages - 2 && (
                  <span className="px-2 py-1">...</span>
                )}
                {totalPages > 5 && currentPage < totalPages - 2 && (
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    className={`btn btn-sm ${
                      totalPages === currentPage
                        ? "bg-danger bg-opacity-10 text-danger"
                        : "bg-white text-dark"
                    }`}
                    style={{ width: "32px", height: "32px" }}
                  >
                    {totalPages}
                  </button>
                )}
              </div>

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className={`btn btn-sm d-flex align-items-center gap-2 ${
                  currentPage === totalPages
                    ? "bg-light text-muted"
                    : "bg-white text-dark"
                }`}
              >
                <span className="ms-1 d-none d-md-inline">Next</span>
                <FaChevronRight size={14} />
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Customer data add popup */}
      {(privileges === "Admin" || privileges === "Manager" || privileges === "Staff") && (
        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          style={{
            display: showModal ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          aria-labelledby="addCustomerModalLabel"
          aria-hidden={!showModal}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{ backgroundColor: "rgb(255, 240, 245)" }}
            >
              <div className="modal-header bg-pink-light border-bottom-0">
                <h5 className="modal-title m-0 fw-semibold">Add Customer</h5>
                <button
                  type="button"
                  className="btn btn-close"
                  onClick={closeModal}
                ></button>
              </div>

              <div className="modal-body bg-pink-light">
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Customer ID <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="customer_id"
                      value={generatedata}
                      readOnly
                      placeholder="Enter Customer ID"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${
                        errors.name ? "is-invalid" : ""
                      }`}
                      name="name"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          name: e.target.value,
                        })
                      }
                      placeholder="Enter Name"
                    />
                    {errors.name && (
                      <div className="invalid-feedback small">{errors.name}</div>
                    )}
                  </div>

                  <div className="col-md-6 mt-1">
                    <label className="form-label small fw-medium">GSTIN</label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${
                        errors.GSTIN ? "is-invalid" : ""
                      }`}
                      name="GSTIN"
                      value={formData.GSTIN}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          GSTIN: e.target.value,
                        })
                      }
                      placeholder="Enter GSTIN (e.g., 22AAAAA0000A1Z5)"
                    />
                    {errors.GSTIN && (
                      <div className="invalid-feedback small">{errors.GSTIN}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-3">
                      Customer Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-select-sm ${
                        errors.customer_type ? "is-invalid" : ""
                      }`}
                      name="customer_type"
                      value={formData.customer_type}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          customer_type: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Customer Type</option>
                      <option value="Regular">Regular</option>
                      <option value="Dealer">Dealer</option>
                    </select>
                    {errors.customer_type && (
                      <div className="invalid-feedback small">
                        {errors.customer_type}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-3">
                      Mobile Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${
                        errors.mobile_number ? "is-invalid" : ""
                      }`}
                      name="mobile_number"
                      value={formData.mobile_number}
                      onChange={(e) => {
                        const onlyDigits = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setFormData({
                          ...formData,
                          mobile_number: onlyDigits,
                        });
                      }}
                      placeholder="Enter Mobile Number"
                      maxLength={10}
                    />
                    {errors.mobile_number && (
                      <div className="invalid-feedback small">
                        {errors.mobile_number}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-3">
                      Address <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className={`form-control form-control-sm ${
                        errors.address ? "is-invalid" : ""
                      }`}
                      name="address"
                      value={formData.address}
                      onChange={(e) =>
                        setFormData({ ...formData, address: e.target.value })
                      }
                      placeholder="Enter Address"
                      rows="2"
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer border-top-0">
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={handleSubmit}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Customer data delete popup */}
      {privileges === "Admin" && (
        <div
          className={`modal fade ${deleteShowModal ? "show" : ""}`}
          style={{
            display: deleteShowModal ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          aria-labelledby="deleteConfirmModalLabel"
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-confirm">
            <div className="modal-content">
              <div className="modal-body text-center">
                <div className="d-flex justify-content-center mb-3">
                  <div
                    className="icon-box bg-light rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                  </div>
                </div>
                <h4 className="modal-title mb-3">Are you sure?</h4>
                <h6 className="mb-4">
                  Do you really want to delete this{" "}
                  <span className="text-primary">{deleteName}</span>?
                </h6>
                <div className="d-flex btn-group">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm flex-grow-1"
                    onClick={() => setDeleteShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm flex-grow-1 mx-2"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Update Customer popup */}
      {(privileges === "Admin" || privileges === "Manager") && (
        <div
          className={`modal fade ${updateModal ? "show" : ""}`}
          style={{
            display: updateModal ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          aria-labelledby="updateCustomerModalLabel"
          aria-hidden={!updateModal}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content rounded"
              style={{ backgroundColor: "rgb(255, 240, 245)" }}
            >
              <div className="modal-header bg-pink-light border-bottom-0">
                <h5 className="modal-title m-0 fw-semibold">Update Customer</h5>
                <button
                  type="button"
                  className="btn btn-close"
                  onClick={() => setUpdateModal(false)}
                ></button>
              </div>

              <div className="modal-body bg-pink-light">
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Customer ID <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="customer_id"
                      value={updateData.customer_id}
                      readOnly
                      placeholder="Enter Customer ID"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${
                        updateErrors.name ? "is-invalid" : ""
                      }`}
                      name="name"
                      value={updateData.name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          name: e.target.value,
                        })
                      }
                      placeholder="Enter Name"
                    />
                    {updateErrors.name && (
                      <div className="invalid-feedback small">
                        {updateErrors.name}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6 mt-1">
                    <label className="form-label small fw-medium">GSTIN</label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${
                        updateErrors.GSTIN ? "is-invalid" : ""
                      }`}
                      name="GSTIN"
                      value={updateData.GSTIN}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          GSTIN: e.target.value,
                        })
                      }
                      placeholder="Enter GSTIN (e.g., 22AAAAA0000A1Z5)"
                    />
                    {updateErrors.GSTIN && (
                      <div className="invalid-feedback small">
                        {updateErrors.GSTIN}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Customer Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-select-sm ${
                        updateErrors.customer_type ? "is-invalid" : ""
                      }`}
                      name="customer_type"
                      value={updateData.customer_type}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          customer_type: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Customer Type</option>
                      <option value="Regular">Regular</option>
                      <option value="Dealer">Dealer</option>
                    </select>
                    {updateErrors.customer_type && (
                      <div className="invalid-feedback small">
                        {updateErrors.customer_type}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Mobile Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${
                        updateErrors.mobile_number ? "is-invalid" : ""
                      }`}
                      name="mobile_number"
                      value={updateData.mobile_number}
                      onChange={(e) => {
                        const digitsOnly = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setUpdateData({
                          ...updateData,
                          mobile_number: digitsOnly,
                        });
                      }}
                      placeholder="Enter Mobile Number"
                      maxLength={10}
                    />
                    {updateErrors.mobile_number && (
                      <div className="invalid-feedback small">
                        {updateErrors.mobile_number}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Address <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className={`form-control form-control-sm ${
                        updateErrors.address ? "is-invalid" : ""
                      }`}
                      name="address"
                      value={updateData.address}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          address: e.target.value,
                        })
                      }
                      placeholder="Enter Address"
                      rows="2"
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer border-top-0">
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => setUpdateModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={handleUpdateSubmit}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerTable;